import type { PageCard } from '@/play/pageTypes'
import { SquishCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'squish',
  number: 2,
  title: 'Squish',
  question: 'Does folding paper over wet ink make a satisfying mirror print?',
  status: 'open',
  accent: '#d8cdea',
  CardArt: SquishCardArt,
}
